// Meta Pixel initialization and tracking utilities

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

export const initMetaPixel = () => {
  try {
    // Only initialize once
    if (window.fbq) return

    // Check if document is ready
    if (typeof document === 'undefined') return

    // Create fbq function
    const fbq: any = function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments)
      } else {
        fbq.queue.push(arguments)
      }
    }

    // Initialize fbq properties
    if (!window.fbq) window.fbq = fbq
    if (!window._fbq) window._fbq = fbq

    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    // Load the Facebook Pixel script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    }

    // Initialize pixel
    window.fbq('init', '1084918860262171')
    window.fbq('track', 'PageView')
  } catch (error) {
    // Fail silently - don't break the app if pixel fails to load
    console.warn('Meta Pixel initialization failed:', error)
  }
}

export const trackAddToCart = () => {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart')
    }
  } catch (error) {
    // Fail silently
    console.warn('Meta Pixel tracking failed:', error)
  }
}
